import React from "react";
import useMonitoredMetersForOrganization from "@/meters/useMonitoredMetersForOrganization";
import { ThaloDataTable } from "@/components/thalo-data-table";
import { Card } from "@/components/ui/card";
import { ColumnDef } from "@tanstack/react-table";
import { Meter } from "@/meters/meter";
import { useNavigate } from "@tanstack/react-router";

const METERS_TABLE_COLUMNS: ColumnDef<Meter>[] = [
  {
    id: "name",
    accessorFn: (row) => row.name,
    header: "Name",
    cell: ({ row }) => (
      <div className="lg:text-lg truncate text-ellipsis">
        {row.original.name}
      </div>
    ),
  },
  {
    id: "num_installations",
    accessorFn: (row) => row.installation_fuel_share_estimates.length,
    header: "Number of assets metered",
    cell: ({ row }) => (
      <div className="lg:text-lg truncate text-ellipsis">
        {row.original.installation_fuel_share_estimates.length}
      </div>
    ),
  }
]

const MetersTable = () => {
  const {
    meters,
    sorting,
    setSorting,
    pagination,
    setPagination
  } = useMonitoredMetersForOrganization();
  const navigate = useNavigate();

  return (
    <Card className="px-4">
      <ThaloDataTable
        showColumnFilter={false}
        data={meters.data?.data.results || []}
        columns={METERS_TABLE_COLUMNS}
        isLoading={meters.isPending}
        sorting={sorting}
        onSortingChange={setSorting}
        pagination={pagination}
        onPaginationChange={setPagination}
        pageCount={1}
        itemsPerPage={20}
        onRowClick={(row) => {
          navigate({ to: "/meters/$meterId", params: { meterId: row.original.id }});
        }}
      />
    </Card>
  )
}

export default MetersTable;
